import { useState } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { useQuery } from '@apollo/client';
import { View, Text, Pressable } from 'react-native-web';

import { ORGANIZATION_LIST_QUERY } from '../../../../features/Filters/FILTER_QUERIES';

import styles from '../styles';

const propTypes = {
  onPress: PropTypes.func.isRequired,
  cityName: PropTypes.string,
};

const defaultProps = {
  cityName: undefined,
};

const CityFilter = ({ onPress, cityName }) => {
  const [showCityDropdown, setShowCityDropdown] = useState(false);

  const { data, loading } = useQuery(ORGANIZATION_LIST_QUERY);

  const toggleCityDropdown = () => {
    setShowCityDropdown(!showCityDropdown);
  };

  const onValueChange = event => onPress(event.target.value);

  return (
    <View style={[styles.container, styles.cityContainer]}>
      <View style={styles.row}>
        {showCityDropdown && !loading ? (
          <Form.Select className="custom-select w-50" value={cityName} onChange={onValueChange}>
            {data?.organizationList?.map(({ _id, name }) => (
              <option key={_id} label={name} value={name} />
            ))}
          </Form.Select>
        ) : (
          <Text style={styles.headerTitle}>City: {cityName}</Text>
        )}

        <Pressable onPress={toggleCityDropdown}>
          <Text style={styles.link}>{showCityDropdown ? 'back' : 'change'}</Text>
        </Pressable>
      </View>
    </View>
  );
};

CityFilter.propTypes = propTypes;
CityFilter.defaultProps = defaultProps;

export default CityFilter;
